module.exports = __webpack_public_path__ + "img/vacina-sesi-logo-branca.f1a4903d.svg";